import { canvasTextWidth } from '../../../fun-js-lib/canvas'

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {import('./line').Line} line 
 * @param {number} lineWidth 
 */
export function getJustificationSpaceWidth (context, line, lineWidth) {
  const normalSpace = spaceWidth(context)
  const nSpaces = line.nSpaces
  if (nSpaces <= 0) {
    return 0
  } else {
    const sumOfWordsWidths = line.getSumOfWordsWidths(context)
    const justificationSpace = (lineWidth - sumOfWordsWidths) / nSpaces
    return justificationSpace < maxSpaceWidth ? justificationSpace : normalSpace
  }
}

/**
 * @param {CanvasRenderingContext2D} context 
 */
export function spaceWidth (context) {
  return canvasTextWidth(context, ' ');
}

const maxSpaceWidth = 40